import { RenterConfigInterface } from './Types';

const ConfigModel = (config?: RenterConfigInterface): RenterConfigInterface => {
  const {
    stripePublicKey = '',
    plaidEnv = '',
    plaidLinkToken = '',
    plaidLinkTokenExpiration = 0,
    enablePaymentStatus = false,
    enableFastPayments = false,
  } = config || {};

  return {
    stripePublicKey,
    plaidEnv,
    plaidLinkToken,
    plaidLinkTokenExpiration,
    enablePaymentStatus,
    enableFastPayments,
  };
};

export default ConfigModel;
